import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonVariant, ButtonSize, ButtonType, ButtonShape } from '../../../core/interfaces';

/**
 * IsButtonComponent
 *
 * Botão dinâmico com variantes, tamanhos, ícones, loading e shapes.
 */
@Component({
  selector: 'is-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() variant: ButtonVariant = 'primary';
  @Input() size: ButtonSize = 'md';
  @Input() type: ButtonType = 'button';
  @Input() shape: ButtonShape = 'default';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() block = false;
  @Input() icon = '';
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() tooltip = '';

  @Output() clicked = new EventEmitter<MouseEvent>();

  get cssClasses(): Record<string, boolean> {
    return {
      'btn': true,
      'is-btn': true,
      [`btn-${this.resolvedVariant}`]: this.variant !== 'ghost',
      [`is-btn--${this.size}`]: true,
      [`is-btn--${this.shape}`]: this.shape !== 'default',
      'is-btn--ghost': this.variant === 'ghost',
      'w-100': this.block,
      'is-btn--icon-only': this.isIconOnly,
      'disabled': this.disabled || this.loading,
    };
  }

  get isIconOnly(): boolean {
    return !!this.icon && (this.shape === 'circle' || this.shape === 'square');
  }

  handleClick(event: MouseEvent): void {
    if (!this.disabled && !this.loading) {
      this.clicked.emit(event);
    }
  }

  private get resolvedVariant(): string {
    return this.variant === 'ghost' ? 'link' : this.variant;
  }
}
